import { Control, ControllStatus, Strategy } from 'src/api/types';
import { formatDate, sanitizeForCSV } from 'src/utils/misc';
import Papa from 'papaparse';
import { ControlCsvHeaders } from 'src/api/types/misc';
import { ControlsQuery } from 'src/graphql/_generated';
import { FiltersType } from './filters/state';
import _ from 'lodash';

type ControlGql = ControlsQuery['controls'][number];

export const downloadCsv = (data: ControlGql[]) => {
  const maxFrameworkControls = Math.max(
    ...data.map((control) => control.frameworkControls?.length || 0),
    1, // Ensure at least one pair
  );

  const frameworkHeaders: string[] = [];
  for (let i = 0; i < maxFrameworkControls; i++) {
    frameworkHeaders.push(ControlCsvHeaders.Framework);
    frameworkHeaders.push(ControlCsvHeaders.FrameworkControlID);
  }

  const rows = [
    [
      ControlCsvHeaders.ID,
      ControlCsvHeaders.Name,
      ControlCsvHeaders.Strategy,
      ControlCsvHeaders.Description,
      ControlCsvHeaders.Owner,
      ControlCsvHeaders.Status,
      ControlCsvHeaders.ExpectedLiveDate,
      ControlCsvHeaders.ActualLiveDate,
      ControlCsvHeaders.ReviewDate,
      ControlCsvHeaders.AnnualCost,
      ControlCsvHeaders.Vendor,
      ControlCsvHeaders.Source,
      ControlCsvHeaders.UrlName,
      ControlCsvHeaders.ExistingMaturity,
      ControlCsvHeaders.TargetMaturity,
      ControlCsvHeaders.Created,
      ControlCsvHeaders.Updated,
      ...frameworkHeaders, // Dynamic framework control pairs
    ],
    ...data.map((el) => {
      const frameworkData: Array<string | number> = [];
      for (let i = 0; i < maxFrameworkControls; i++) {
        const frameworkControl = el.frameworkControls?.[i];
        if (frameworkControl) {
          frameworkData.push(sanitizeForCSV(frameworkControl.controlFramework?.shortname));
          frameworkData.push(sanitizeForCSV(frameworkControl.control_identifier));
        } else {
          frameworkData.push('');
          frameworkData.push('');
        }
      }

      return [
        sanitizeForCSV(el.id),
        sanitizeForCSV(el.name),
        sanitizeForCSV(el.strategy),
        sanitizeForCSV(el.description),
        sanitizeForCSV(el.owner?.text),
        sanitizeForCSV(el.status),
        formatDate(el.expectedActiveDate),
        formatDate(el.actualActiveDate),
        formatDate(el.reviewDate),
        sanitizeForCSV(el.annualCost),
        sanitizeForCSV(el.vendor),
        sanitizeForCSV(el.linkUrl),
        sanitizeForCSV(el.linkText),
        sanitizeForCSV(el.existingMaturity),
        sanitizeForCSV(el.targetMaturity),
        formatDate(el.meta?.createdAt, {
          formatType: 'datetime',
        }),
        formatDate(el.meta?.updatedAt, {
          formatType: 'datetime',
        }),
        ...frameworkData, // Dynamic framework control pairs
      ];
    }),
  ];
  const csvString = Papa.unparse(rows, { delimiter: ';' });
  const anchor = document.createElement('a');
  anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURIComponent(csvString);
  anchor.target = '_blank';
  anchor.download = `Risk Management Plan Export.csv`;
  anchor.click();
};

export const pickFilter = (filter: FiltersType[keyof FiltersType][number]) => _.pick(filter, ['unifiedKey', 'enabled']);
